import React from "react";
import PageLayout from "./PageLayout";
import Courses from "../sections/Courses";

export default function CoursesPage() {
    return (
        <PageLayout testId="courses-page" pageTitle="Kurslarımız">
            <Courses standalone />
        </PageLayout>
    );
}
